module.exports = __webpack_public_path__ + "img/biaoti.6e3dce67.png";